export default "__VITE_ASSET__40a5fb82__"